export default __webpack_public_path__ + "fa58704eb14831e4b6d9ed6071bb0615.png";